<template>
  <v-list class="files-wrap pb-0">
    <v-list-item>
      <v-list-item-icon><v-icon small color="transparent"></v-icon></v-list-item-icon>
      <v-list-item-content>
        <v-row dense class="transparent">
          <v-col cols="8" class="blue-grey--text text--darken-4 pa-0">
            <v-btn text :class="currentOrderField === 'name' ? 'font-weight-bold' : ''" @click="orderBy('name')">
              <span>名前</span>
              <span v-if="currentOrderField === 'name'">
                <v-icon small>{{ printOrderDirectionIcon }}</v-icon>
              </span>
            </v-btn>
          </v-col>
          <v-col cols="2" align-self="center" class="blue-grey--text text-right text--darken-4 pa-0">
            <v-btn text :class="currentOrderField === 'modified_at' ? 'font-weight-bold' : ''" @click="orderBy('modified_at')">
              <span>更新日</span>
              <span v-if="currentOrderField === 'modified_at'">
                <v-icon small>{{ printOrderDirectionIcon }}</v-icon>
              </span>
            </v-btn>
          </v-col>
          <v-col cols="2" align-self="center" class="blue-grey--text text-right text--darken-4 pa-0">
            <v-btn text :class="currentOrderField === 'size' ? 'font-weight-bold' : ''" @click="orderBy('size')">
              <span>サイズ</span>
              <span v-if="currentOrderField === 'size'">
                <v-icon small>{{ printOrderDirectionIcon }}</v-icon>
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon disabled></v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'cli-filer-header',
  props: [
    'order'
  ],
  data () {
    return {
      meta: {
        dir: {
          asc: ['fal', 'fa-sort-numeric-down'],
          desc: ['fal', 'fa-sort-numeric-up']
        }
      }
    }
  },
  methods: {
    orderBy: function (type) {
      if (type) {
        this.$emit('emit', {
          action: 'orderBy',
          data: type
        })
      }
    }
  },
  computed: {
    currentOrderField () {
      return (this.$props.order && this.$props.order.field) ? this.$props.order.field : ''
    },
    printOrderDirectionIcon () {
      return (
        this.$props.order &&
        this.$props.order.dir &&
        this.meta.dir[this.$props.order.dir]
      ) ? this.meta.dir[this.$props.order.dir].join(' ') : ''
    }
  }
}
</script>